var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('appResult')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/partner/PartnerPanel.vue